import React from 'react'

function SkeletonList() {
  return (
    <>
      <div className="skel" />
      <div className="skel" />
      <div className="skel" />
    </>
  )
}

export default SkeletonList
